import { useSetRecoilState } from 'recoil'
import { userLists } from 'src/atoms/user-lists'
import { userListsClient } from 'src/clients'
import { useAuthData } from 'src/components/auth/util'

export const useSetUpUserLists = () => {
  const setUserLists = useSetRecoilState(userLists)
  const authData = useAuthData()

  const setUpUserLists = async () => {
    if (!authData) {
      setUserLists([])
      return
    }
    try {
      const res = await userListsClient.getAllLists()
      setUserLists(res)
    } catch (error) {
      setUserLists([])
    }
  }

  return { setUpUserLists }
}
